<script setup>
	import VuePdfApp from 'vue3-pdf-app'
	import 'vue3-pdf-app/dist/icons/main.css'

	// properties
	const props = defineProps(['imageURL', 'style'])

	const config = {
		sidebar: {
			viewThumbnail: true,
			viewOutline: false,
			viewAttachments: false
		},
		secondaryToolbar: {
			secondaryPresentationMode: true,
			secondaryOpenFile: false,
			secondaryPrint: true,
			secondaryDownload: false,
			secondaryViewBookmark: false,
			firstPage: false,
			lastPage: false,
			pageRotateCw: true,
			pageRotateCcw: true,
			cursorSelectTool: false,
			cursorHandTool: false,
			scrollVertical: false,
			scrollHorizontal: false,
			scrollWrapped: false,
			spreadNone: false,
			spreadOdd: false,
			spreadEven: false,
			documentProperties: false
		},
		toolbar: {
			toolbarViewerLeft: {
				findbar: true,
				previous: true,
				next: true,
				pageNumber: true
			},
			toolbarViewerRight: {
				presentationMode: true,
				openFile: false,
				print: false,
				download: false,
				viewBookmark: false
			},
			toolbarViewerMiddle: {
				zoomOut: true,
				zoomIn: true,
				scaleSelectContainer: true
			}
		},
		errorWrapper: true
	}
	const pagesRenderedHandler = (pdfApp) => {
		setTimeout(() => {
			pdfApp.pdfViewer.currentScaleValue = 'auto'
		})
	}
</script>
<template>
	<vue-pdf-app
		:style="props.style ?? 'height:170vh; width:1000px;'"
		:pdf="props.imageURL"
		:config="config"
		@pages-rendered="pagesRenderedHandler"
	>
	</vue-pdf-app>
</template>
